"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _Browser = _interopRequireDefault(require("@instructure/ui-utils/lib/Browser"));

var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));

var _uid = _interopRequireDefault(require("@instructure/uid"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class, _class2, _temp;

var styles = {
  componentId: 'cvEmo',
  template: function template(theme) {
    return "\n\n@keyframes cvEmo_dpDr{to{transform:rotate(360deg)}}\n\n@keyframes cvEmo_buIf{0%{stroke-dashoffset:190%}50%{stroke-dashoffset:50%;transform:rotate(90deg)}to{stroke-dashoffset:190%;transform:rotate(360deg)}}\n\n.cvEmo_bGBk{box-sizing:border-box;display:inline-block;overflow:hidden;position:relative;vertical-align:middle}\n\n.cvEmo_dfBC,.cvEmo_dfBC .cvEmo_cJVF{height:".concat(theme.xSmallSize || 'inherit', ";width:").concat(theme.xSmallSize || 'inherit', "}\n\n.cvEmo_dfBC .cvEmo_cUeT{stroke-width:calc(").concat(theme.xSmallBorderWidth || 'inherit', "*1.75)}\n\n.cvEmo_dfBC .cvEmo_eWAY,.cvEmo_dfBC .cvEmo_dTxv{stroke-width:").concat(theme.xSmallBorderWidth || 'inherit', "}\n\n.cvEmo_dfBC .cvEmo_eWAY{stroke-dasharray:3em;transform-origin:calc(").concat(theme.xSmallSize || 'inherit', "/2) calc(").concat(theme.xSmallSize || 'inherit', "/2)}\n\n.cvEmo_doqw,.cvEmo_doqw .cvEmo_cJVF{height:").concat(theme.smallSize || 'inherit', ";width:").concat(theme.smallSize || 'inherit', "}\n\n.cvEmo_doqw .cvEmo_cUeT{stroke-width:calc(").concat(theme.smallBorderWidth || 'inherit', "*1.75)}\n\n.cvEmo_doqw .cvEmo_eWAY,.cvEmo_doqw .cvEmo_dTxv{stroke-width:").concat(theme.smallBorderWidth || 'inherit', "}\n\n.cvEmo_doqw .cvEmo_eWAY{stroke-dasharray:6em;transform-origin:calc(").concat(theme.smallSize || 'inherit', "/2) calc(").concat(theme.smallSize || 'inherit', "/2)}\n\n.cvEmo_ycrn,.cvEmo_ycrn .cvEmo_cJVF{height:").concat(theme.mediumSize || 'inherit', ";width:").concat(theme.mediumSize || 'inherit', "}\n\n.cvEmo_ycrn .cvEmo_cJVF{stroke-width:").concat(theme.mediumBorderWidth || 'inherit', "}\n\n.cvEmo_ycrn .cvEmo_cUeT{stroke-width:calc(").concat(theme.mediumBorderWidth || 'inherit', "*1.75)}\n\n.cvEmo_ycrn .cvEmo_eWAY,.cvEmo_ycrn .cvEmo_dTxv{stroke-width:").concat(theme.mediumBorderWidth || 'inherit', "}\n\n.cvEmo_ycrn .cvEmo_eWAY{stroke-dasharray:10.5em;transform-origin:calc(").concat(theme.mediumSize || 'inherit', "/2) calc(").concat(theme.mediumSize || 'inherit', "/2)}\n\n.cvEmo_cMDj,.cvEmo_cMDj .cvEmo_cJVF{height:").concat(theme.largeSize || 'inherit', ";width:").concat(theme.largeSize || 'inherit', "}\n\n.cvEmo_cMDj .cvEmo_cJVF{stroke-width:").concat(theme.largeBorderWidth || 'inherit', "}\n\n.cvEmo_cMDj .cvEmo_cUeT{stroke-width:calc(").concat(theme.largeBorderWidth || 'inherit', "*1.75)}\n\n.cvEmo_cMDj .cvEmo_eWAY,.cvEmo_cMDj .cvEmo_dTxv{stroke-width:").concat(theme.largeBorderWidth || 'inherit', "}\n\n.cvEmo_cMDj .cvEmo_eWAY{stroke-dasharray:14em;transform-origin:calc(").concat(theme.largeSize || 'inherit', "/2) calc(").concat(theme.largeSize || 'inherit', "/2)}\n\n.cvEmo_cJVF{animation-duration:2.25s;animation-iteration-count:infinite;animation-name:cvEmo_dpDr;animation-timing-function:linear;display:block;left:0;position:absolute;top:0}\n\n.cvEmo_cUeT,.cvEmo_eWAY,.cvEmo_dTxv{fill:none}\n\n.cvEmo_eWAY{stroke-linecap:round}\n\n.cvEmo_bGBk:not(.cvEmo_eoSs) .cvEmo_eWAY{animation-duration:1.75s;animation-iteration-count:infinite;animation-name:cvEmo_buIf;animation-timing-function:ease}\n\n.cvEmo_bGBk.cvEmo_eoSs .cvEmo_eWAY{stroke-dashoffset:100%}\n\n.cvEmo_ddES .cvEmo_cUeT{stroke:none}\n\n.cvEmo_ddES .cvEmo_dTxv{stroke:").concat(theme.trackColor || 'inherit', "}\n\n.cvEmo_ddES .cvEmo_eWAY{stroke:").concat(theme.color || 'inherit', "}\n\n.cvEmo_enfx .cvEmo_cUeT{stroke:rgba(0,0,0,0.3)}\n\n.cvEmo_enfx .cvEmo_dTxv{stroke:").concat(theme.inverseTrackColor || 'inherit', "}\n\n.cvEmo_enfx .cvEmo_eWAY{stroke:").concat(theme.inverseColor || 'inherit', "}");
  },
  'root': 'cvEmo_bGBk',
  'x-small': 'cvEmo_dfBC',
  'circle': 'cvEmo_cJVF',
  'circleShadow': 'cvEmo_cUeT',
  'circleSpin': 'cvEmo_eWAY',
  'circleTrack': 'cvEmo_dTxv',
  'small': 'cvEmo_doqw',
  'medium': 'cvEmo_ycrn',
  'large': 'cvEmo_cMDj',
  'rotate': 'cvEmo_dpDr',
  'ie11': 'cvEmo_eoSs',
  'morph': 'cvEmo_buIf',
  'default': 'cvEmo_ddES',
  'inverse': 'cvEmo_enfx'
};
var Spinner = (
/**
---
category: components
---
**/
_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Spinner, _Component);

  function Spinner(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Spinner);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Spinner).call(this));
    _this.titleId = (0, _uid.default)('Spinner');
    return _this;
  }

  (0, _createClass2.default)(Spinner, [{
    key: "radius",
    value: function radius() {
      switch (this.props.size) {
        case 'x-small':
          return '0.5em';

        case 'small':
          return '1em';

        case 'large':
          return '2.25em';

        default:
          return '1.75em';
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;

      var ie11 = _Browser.default.msie && _Browser.default.version > 10;
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles[this.props.size], true), (0, _defineProperty2.default)(_classes, styles[this.props.variant], true), (0, _defineProperty2.default)(_classes, styles.ie11, ie11), _classes);

      var passthroughProps = _View.default.omitViewProps((0, _passthroughProps.omitProps)(this.props, Spinner.propTypes), Spinner);

      return _react.default.createElement(_View.default, Object.assign({}, passthroughProps, {
        as: this.props.as,
        elementRef: this.props.elementRef,
        className: (0, _classnames.default)(classes),
        margin: this.props.margin
      }), _react.default.createElement("svg", {
        className: styles.circle,
        role: "img",
        "aria-labelledby": this.titleId,
        focusable: "false"
      }, _react.default.createElement("title", {
        id: this.titleId
      }, this.props.title), _react.default.createElement("g", {
        role: "presentation"
      }, _react.default.createElement("circle", {
        className: styles.circleShadow,
        cx: "50%",
        cy: "50%",
        r: this.radius()
      }), _react.default.createElement("circle", {
        className: styles.circleTrack,
        cx: "50%",
        cy: "50%",
        r: this.radius()
      }), _react.default.createElement("circle", {
        className: styles.circleSpin,
        cx: "50%",
        cy: "50%",
        r: this.radius()
      }))));
    }
  }]);
  Spinner.displayName = "Spinner";
  return Spinner;
}(_react.Component), _class2.propTypes = {
  /**
  * Give the spinner a title to be read by screenreaders
  */
  title: _propTypes.default.string.isRequired,

  /**
  * Different-sized spinners
  */
  size: _propTypes.default.oneOf(['x-small', 'small', 'medium', 'large']),

  /**
  * Different color schemes for use with light or dark backgrounds
  */
  variant: _propTypes.default.oneOf(['default', 'inverse']),

  /**
  * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing,
  elementRef: _propTypes.default.func,
  as: _propTypes.default.elementType
}, _class2.defaultProps = {
  as: 'div',
  size: 'medium',
  variant: 'default',
  margin: void 0,
  elementRef: void 0
}, _temp)) || _class) || _class);
exports.default = Spinner;